// @flow

export const is24Hours = (place: ServiceProvider):boolean => {
  if (place._embedded.tags.length > 0) {
    const tags = place._embedded.tags.filter(t => t.slug === '24-hours')
    if (tags.length > 0) {
      return true
    }
  }
  return false
}